module.exports = __webpack_public_path__ + "img/gitter.b4bfb913.svg";